import { InfoBox } from "@jsq/ds/core";
import { bannerWrapper, existingProfileLink } from "./styles_vanilla.css";
import { getTaxIdLabel } from "./utils";

type ExistingProfileBannerProps = {
  taxIdType?: string | null;
  onViewExistingProfile?: () => void;
  className?: string;
};

export const ExistingProfileBanner = ({
  taxIdType,
  onViewExistingProfile,
  className,
}: ExistingProfileBannerProps) => {
  const label = getTaxIdLabel(taxIdType);
  return (
    <InfoBox
      variant="info"
      title={`Profile already exists for the provided ${label}`}
      className={[bannerWrapper, className].filter(Boolean).join(" ")}
    >
      Verify the {label} is correct. If it is accurate, go back to view and assign{" "}
      {onViewExistingProfile ? (
        <button type="button" className={existingProfileLink} onClick={onViewExistingProfile}>
          an existing profile
        </button>
      ) : (
        "an existing profile"
      )}{" "}
      to this case, or continue to create a new profile.
    </InfoBox>
  );
};
